/* Shop the Look — gallery filters, size selection, cart.
   Vanilla, no dependencies. Both sections load this file; each half runs only
   if its markup is on the page. */
(function () {
  'use strict';

  if (window.__stlInit) return;   // section may be rendered twice in the editor
  window.__stlInit = true;

  /* Shopify.routes exists on OS 2.0 themes; fall back for older ones and for
     stores served from a subpath. */
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------------- toast ---------------- */

  var toastTimer;
  function toast(msg) {
    var el = document.querySelector('[data-stl-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-on'); }, 2400);
  }

  /* ---------------- cart ---------------- */

  function addToCart(items) {
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json().then(function (body) {
        if (!res.ok) throw new Error(body.description || body.message || 'Could not add to bag');
        return body;
      });
    });
  }

  /* Tell the theme its cart changed. Different themes listen for different
     things, so publish to Shopify's bus when present and also fire a plain
     event the theme may already bind. */
  function cartChanged() {
    try {
      if (window.PUB_SUB_EVENTS && window.publish) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'shop-the-look' });
      }
    } catch (e) { /* theme without the pub/sub helper */ }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
  }

  /* ---------------- gallery ---------------- */

  function initGallery(root) {
    var filters = root.querySelector('[data-stl-filters]');
    var grid = root.querySelector('[data-stl-grid]');
    if (!filters || !grid) return;

    var empty = grid.querySelector('[data-stl-empty]');

    filters.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-filter]');
      if (!btn) return;

      filters.querySelectorAll('button').forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
      });

      var want = btn.dataset.filter;
      var shown = 0;

      grid.querySelectorAll('.stl-tile').forEach(function (tile) {
        /* Pipe-delimited with leading and trailing pipes, so a substring
           test cannot half-match one tag against another. */
        var tags = tile.dataset.tags || '';
        var match = want === 'all' || tags.indexOf('|' + want + '|') !== -1;
        tile.hidden = !match;
        if (match) shown++;
      });

      if (empty) empty.hidden = shown !== 0;
    });
  }

  /* ---------------- look detail ---------------- */

  function initLook(root) {
    var items = root.querySelectorAll('[data-stl-item]');

    /* --- hero gallery --- */
    var rail = root.querySelector('[data-stl-rail]');
    var heroImg = root.querySelector('.stl-hero__img');
    var counter = root.querySelector('[data-stl-count]');
    var shotsTag = root.querySelector('[data-stl-shots]');
    var shots = [];

    try { shots = JSON.parse(shotsTag.textContent) || []; } catch (e) { shots = []; }

    function showShot(i) {
      if (!heroImg || !shots[i]) return;
      heroImg.src = shots[i].src;
      heroImg.removeAttribute('srcset');
      heroImg.setAttribute('style', shots[i].frame);
      if (counter) counter.textContent = (i + 1) + ' / ' + shots.length;
      if (rail) {
        rail.querySelectorAll('button').forEach(function (b) {
          b.classList.toggle('is-active', Number(b.dataset.shot) === i);
        });
      }
    }

    if (shots.length > 1 && counter) counter.textContent = '1 / ' + shots.length;

    if (rail) {
      rail.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-shot]');
        if (b) showShot(Number(b.dataset.shot));
      });
    }

    /* --- per-row size selection --- */

    function stockLine(row) {
      var out = row.querySelector('[data-stl-stock]');
      if (!out) return;

      var active = row.querySelector('[data-stl-size].is-active');
      if (!active) { out.textContent = ''; out.classList.remove('is-low'); return; }

      var qty = Number(active.dataset.qty);
      var low = Number(out.dataset.low || 3);
      var size = active.dataset.size;

      if (qty <= 0) {
        out.textContent = 'Sold out in ' + size;
        out.classList.add('is-low');
      } else if (low > 0 && qty <= low) {
        out.textContent = 'Only ' + qty + ' left in ' + size;
        out.classList.add('is-low');
      } else {
        out.textContent = 'In stock';
        out.classList.remove('is-low');
      }
    }

    items.forEach(function (row) { stockLine(row); });

    root.addEventListener('click', function (e) {
      /* size */
      var size = e.target.closest('[data-stl-size]');
      if (size && !size.disabled) {
        var row = size.closest('[data-stl-item]');
        row.querySelectorAll('[data-stl-size]').forEach(function (b) {
          b.classList.toggle('is-active', b === size);
        });
        row.querySelector('[data-stl-variant]').value = size.dataset.variant;

        var now = row.querySelector('[data-stl-now]');
        var was = row.querySelector('[data-stl-was]');
        if (now) now.textContent = size.dataset.price;
        if (was) {
          was.textContent = size.dataset.compare || '';
          was.hidden = !size.dataset.compare;
        }

        stockLine(row);
        return;
      }

      /* add one */
      var add = e.target.closest('[data-stl-add]');
      if (add && !add.disabled) {
        var itemRow = add.closest('[data-stl-item]');
        var id = itemRow.querySelector('[data-stl-variant]').value;
        var label = itemRow.querySelector('.stl-item__title').textContent.trim();

        add.disabled = true;
        addToCart([{ id: Number(id), quantity: 1 }])
          .then(function () {
            cartChanged();
            add.classList.add('is-added');
            add.textContent = 'Added ✓';
            toast(shorten(label) + ' added to bag');
            setTimeout(function () {
              add.classList.remove('is-added');
              add.textContent = 'Add to bag';
              add.disabled = false;
            }, 1800);
          })
          .catch(function (err) {
            add.disabled = false;
            toast(err.message);
          });
      }
    });

    /* --- add the whole look --- */

    var addAll = root.querySelector('[data-stl-add-all]');
    if (addAll) {
      addAll.addEventListener('click', function () {
        var payload = [];
        items.forEach(function (row) {
          var btn = row.querySelector('[data-stl-add]');
          if (btn && btn.disabled && !btn.classList.contains('is-added')) return; // sold out
          var id = row.querySelector('[data-stl-variant]').value;
          if (id) payload.push({ id: Number(id), quantity: 1 });
        });

        if (!payload.length) { toast('Nothing in this look is in stock'); return; }

        var original = addAll.textContent;
        addAll.disabled = true;
        addAll.textContent = 'Adding…';

        addToCart(payload)
          .then(function () {
            cartChanged();
            var code = root.dataset.discountCode;
            if (code) {
              /* The discount is what actually charges the customer, so hand the
                 cart over to Shopify to apply it rather than claiming the
                 bundle price here. */
              window.location.href = ROOT +
                'discount/' + encodeURIComponent(code) +
                '?redirect=' + encodeURIComponent(ROOT + 'cart');
              return;
            }
            addAll.textContent = original;
            addAll.disabled = false;
            toast(payload.length + ' pieces added to bag');
          })
          .catch(function (err) {
            addAll.textContent = original;
            addAll.disabled = false;
            toast(err.message);
          });
      });
    }
  }

  function shorten(t) {
    if (t.length <= 34) return t;
    var cut = t.slice(0, 34);
    return cut.slice(0, cut.lastIndexOf(' ')) + '…';
  }

  /* ---------------- boot ---------------- */

  function boot() {
    document.querySelectorAll('[data-stl-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-stl-look]').forEach(initLook);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor re-renders sections without a page load. */
  document.addEventListener('shopify:section:load', function (e) {
    window.__stlInit = false;
    var g = e.target.querySelector('[data-stl-gallery]');
    var l = e.target.querySelector('[data-stl-look]');
    if (g) initGallery(g);
    if (l) initLook(l);
    window.__stlInit = true;
  });
})();
